import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Column from "components/table/column"

export default memo(shapeComponent(class CardTableColumn extends ShapeComponent {
  render() {
    const {style, ...restProps} = this.props

    return (
      <Column style={this.tt.styleCallback} {...restProps} />
    )
  }

  styleCallback = ({column, rowContext, style, tableContext}) => {
    const columnPosition = column.tt.position
    const rowPosition = rowContext.row.tt.position

    const columnsCount = tableContext.table.headersCount
    const rowsCount = tableContext.table.rowsCount

    style.backgroundColor = "#fff"
    style.padding = 15

    style.borderColor = "#e5dfff"
    style.borderStyle = "solid"
    style.borderBottomWidth = 1

    if (columnPosition == 0 && rowPosition == rowsCount - 1) {
      style.borderBottomLeftRadius = 8
    }

    if (columnPosition == columnsCount - 1 && rowPosition == rowsCount - 1) {
      style.borderBottomRightRadius = 8
    }

    if (columnPosition == 0) {
      style.borderLeftWidth = 1
    }

    if (columnPosition == columnsCount - 1) {
      style.borderRightWidth = 1
    }

    if (this.props.style) {
      Object.assign(style, this.props.style)
    }
  }
}))
